import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=3e54d3b4&scoped=true"
import script from "./Body.vue?vue&type=script&lang=ts"
export * from "./Body.vue?vue&type=script&lang=ts"
import style0 from "./Body.vue?vue&type=style&index=0&id=3e54d3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54d3b4",
  null
  
)

export default component.exports